import React, { useState, useEffect } from 'react';
import { commonSelector } from '../Common/redux/selectors';
import { useSelector } from 'react-redux';
import { Helmet } from 'react-helmet';
import FAQ from '../CommonResp/FAQ/FAQ';
import Footer from '../CommonResp/Footer/Footer';
import Heading from '../CommonResp/Heading/Heading';
import Breadcrumbs from '../CommonResp/BreadcrumbsWithoutSchema/Breadcrumbs';
import { isMobileView } from '../Common/utils';
import { redirectToFunnel } from '../Common/utils/redirectToFunnel';
import Carousel from '../CommonResp/Carousel/Carousel';
import MobileHeader from '../CommonResp/MobileHeader/MobileHeader';
import TemplateContent from '../CommonResp/Content/Content';
import { getBreadCrumbObj } from './../CommonResp/utils';
import SeoContainerHeader from "../Common/SeoContainerHeader";
import PageNotFound from '../CommonResp/PageNotFoud/PageNotFound';
import AdBanner from './../../components/AdBanner/AdBanner';
import CrossTemplate from '../CommonResp/CrossTemplate/CrossTemplateTile';
import { standDataSelector } from './redux/selectors';
import ListingWidget from '../CommonResp/ListingWidget/ListingWidget';
import { calculateDaysToTrip, ctaHelper, CTA_TYPE, getDate, sendPageViewEvent, trackActionEvent } from '../../utils/Omniture';
import { PAGE_NAMES } from '../config/constants';


const StandPage = (props) => {
  const {isBusStop = true} = props;
  const commonData = useSelector(commonSelector);
  const standData = useSelector(standDataSelector);
  const [showClientContent, enableClient] = useState(false);
  const mobileView = isMobileView();

  function getPageName({ isBusStop }) {
    if (isBusStop) return PAGE_NAMES.busstop;
    return  PAGE_NAMES.route;
  }
  useEffect(() => {
    enableClient(true);
    const eventDetails = {
      pageName: getPageName({ isBusStop })
    }
    sendPageViewEvent(eventDetails)
  }, []);

  const { date, stand_name, canonical_url, footer_links, from_buses = [], offers = [], seo_meta = {}, template = {},
    to_buses = [], cross_template_links = {}, titles = {}, general_contents = [], notToCrawl = false, notToIndex=false } = standData;

  const { doj, } = commonData;
  const data_date = date ? date : doj;
  const { faq = {}, contents = [], content = "" } = template || {};
  const renderOfferCarousel = showClientContent && offers && offers.length ? true : false;

  const moveToFunnel = (params,eventName = 'viewBuses', track=true) => {
         let cta_data =  eventName == 'busUpdateSearch' 
       ?  ['Update_Search', CTA_TYPE.BUTTON, 'Header', 'SRP']
       : ['VIEW BUSES', CTA_TYPE.BUTTON, 'Body', 'SRP']
        const eventDetails = {
            cta: ctaHelper(cta_data),
            booking: {
                routeCity: '',
                routeState: '',
                daysToTrip: calculateDaysToTrip(getDate(date)),
                departureDate: date,
            }
        };
        if (track) {
            trackActionEvent(eventName, eventDetails, { gloabl: true });
        }

    redirectToFunnel({ ...params, data_date })
  }

  const onUpdateSearch = (data) => {
    moveToFunnel({ page: "home", prefillData: true, data: data }, 'busUpdateSearch');
  }

  const { h1_title = "", meta_title = "", meta_description = "", meta_keywords = "", breadcrumb = "" } = seo_meta;

  const breadCrumbObj = getBreadCrumbObj(breadcrumb, canonical_url);

  const adTechId = (() => {
    return "QlVTI0NJVFkgU0VPI1ZJRVcgTU9SRSBCVVNFUw=="
  })();

  return (
    <>
      <Helmet
        title={meta_title}
        meta={
          [{ name: 'description', content: meta_description },
          { name: 'keywords', content: meta_keywords },
          { property: 'og:title', content: meta_title },
          { property: 'og:description', content: meta_description },
          { property: 'og:image', content: 'https://gos3.ibcdn.com/bus-default-1489655303.jpg' },
          { property: 'og:url', content: canonical_url },
          notToCrawl  ? { name: 'robots', content: 'noindex,nofollow' } : '',
          notToIndex  ? { name: 'robots', content: 'noindex' } : '',
          ]
        }
        link={[
          {
            href: canonical_url,
            rel: 'canonical',
          },
        ]}
      />
      {notToCrawl ?
        <PageNotFound
          date={data_date}
          onUpdateSearch={onUpdateSearch}
          showHeaderOnly={notToCrawl}
          footer_links={footer_links}
        ></PageNotFound>
        : <>
          <Helmet>
            <script type="application/ld+json">{`${JSON.stringify(breadCrumbObj)}`}</script>
          </Helmet>
          <div className="seoContainer">
            <div className="desktopOnly">
              <SeoContainerHeader
                date={data_date}
                onUpdateSearch={onUpdateSearch}
              />
            </div>

            {showClientContent ?
              <MobileHeader
                title={h1_title}
                date={data_date}
                moveToFunnel={moveToFunnel}>
              </MobileHeader>
              : <></>}

            <div className="ContentWrapper">
              <div className="contentSection operatorsContentScetion">
                <div className="RgtSection">
                  <Heading content={h1_title}></Heading>
                  <Breadcrumbs content={breadcrumb}></Breadcrumbs>
                  <TemplateContent data={general_contents} className="seoDescTitle"></TemplateContent>
                </div>
                <div className="LftSection">
                  {renderOfferCarousel && !mobileView ? <Carousel content={offers} count={isMobileView() ? offers.length : 1} lazyload={false}></Carousel> : null}
                </div>
              </div>

              {to_buses && to_buses.length ?
                <>
                  <p className="listingHeading">{titles?.to_buses_msg ?? `Book Buses to ${stand_name}`}</p>
                  <ListingWidget
                    content={to_buses}
                    moveToFunnel={moveToFunnel}
                    showClientContent={showClientContent}
                  />
                </>
                : <></>}

              {from_buses && from_buses.length ?
                <>
                  <p className="listingHeading">{titles?.from_buses_msg ?? `Book Buses From ${stand_name}`}</p>
                  <ListingWidget
                    content={from_buses}
                    moveToFunnel={moveToFunnel}
                    showClientContent={showClientContent}
                  />
                </>
                : <></>}

              {showClientContent ? <AdBanner cid={adTechId} /> : <></>}

              <TemplateContent className="whiteCard" data={contents} content={content}></TemplateContent>

              <FAQ data={faq}></FAQ>

              <div className="whiteCardWrapper">
                <CrossTemplate cross_template_links={cross_template_links} />
              </div>
            </div>
            <Footer data={footer_links}></Footer>
          </div>
        </>}
    </>
  )
}
export default StandPage;
